<template>
	<div class="modal is-active">
		<div class="modal-background"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title" >Adicionar Categoria</p>
				<button class="delete" aria-label="close" @click="goBack"></button>
			</header>
			<section class="modal-card-body" v-show="isLoading">
				<Spinner size="30" />
			</section>
			<form @submit.prevent="onSubmit()" v-show="!isLoading">

				<section class="modal-card-body" >

					<p>Olá. Você está prestes a adicionar uma nova categoria.<br>
					Título: <span class="blue">{{ category.name }}</span><br>
					<span v-if="category.userName">Compartilhada por: <span class="blue">{{ category.userName }}</span></span></p>


				</section>

				<footer class="modal-card-foot">
					<button type="submit" class="button is-success">Aceitar</button>
					<button class="button" @click.prevent="goBack">Recusar</button>
				</footer>

			</form>
		</div>
	</div>
</template>

<style>

	.blue { color:#0057ff; }


fieldset + fieldset {
  margin-top: 15px;
}
fieldset legend{
  text-align: center;
  margin-bottom: 10px;
}


</style>

<script>

import firebase from '@/firebase'
import Spinner from '../components/Spinner'

export default {
	components:{
		Spinner
	},
	data() {
		return {
			sharedCategoryId: '',
			isLoading:false,
			category:{},
		}
	},
	computed: {
		userId() {
			return this.$store.getters.userId;
		},
	},
	methods:{
		goBack(){
			this.$router.push({name:'home'});
		},
		onSubmit(){

			console.log('batch started');
			const db = firebase.firestore();
			this.$store.dispatch('startLoading');

			let userRef = db.collection('users').doc(this.userId);


			let category = this.category;
			let category_id = null;

			userRef.collection('categories').add({
				name:category.name,
				column:1,
				index:0.5,
			}).then(docRef => {

    		category_id = docRef.id;
				let batch = db.batch();

				let l;
				for(l in category.links){
					let newLink = userRef.collection('links').doc();
					batch.set(newLink, {
						category_id:category_id,
						favicon:category.links[l].favicon,
						name:category.links[l].name,
						url:category.links[l].url,
						index:category.links[l].index,
					});
				}

				batch.commit().then(() => {
					console.log('batch finished');
					console.log('query started');
					var q1 = this.$store.dispatch('queryCategories');
					var q2 = this.$store.dispatch('queryLinks');
					Promise.all([q1, q2]).then(()=>{
						console.log('query finished');
						this.$store.dispatch('stopLoading');
						this.$router.push({name:'home'});
					})
				});

			}).catch(error => {
				this.$store.dispatch('stopLoading');
				alert('unknown error');
			})

		},
	},
	mounted() {
		this.isLoading = true;
		let uid = this.$store.state.sharedCategoryId;
		this.$store.dispatch('setSharedCategoryId',{id:''});
		this.sharedCategoryId = uid;

		const db = firebase.firestore();
		db.collection('shared_categories').doc(uid).get().then(doc=>{
			this.category = doc.data();
			this.isLoading = false;
		}).catch(()=>{
			this.isLoading = false;
		})

	},
};
</script>

